/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-empty-function */
import { Component } from "@angular/core";
import * as C from "src/app/shared/constants/globals.constants";
import * as ProfileModel from "src/app/shared/models/profile.model";

@Component({
  selector: "rs-ewiz-dynamic-class-component",
  template: "",
  standalone: false
})
export class EWizDynamicBaseClassComponent {
  C = C;
  profileValues: ProfileModel.ProfileDto | null = null;
  errorFound = false;
  errorMessage = "";
  overallState = null;

  handleFormEvents(event?: any) {}

  showTip(event?: any) {}

  showGuidance(event?: any) {}

  clearDynamicToast(event?: any) {}
}
